import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data-test-id", "use", "children"];
import { View } from '../../../components/View';
import { Text } from '../../../components/Text';
import { getBadgeStyles, CountStyles } from './Badge.helpers';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const Dot = styled.span.withConfig({
  displayName: "Badge__Dot",
  componentId: "cnf31v-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    display: 'inline-block',
    backgroundColor: theme.color['fill-accent-magenta-default'],
    borderInlineWidth: theme.borderWidth['100'],
    borderBlockWidth: theme.borderWidth['100'],
    borderInlineStyle: 'solid',
    borderBlockStyle: 'solid',
    borderInlineColor: theme.color['border-primary-on-fill'],
    borderBlockColor: theme.color['border-primary-on-fill'],
    borderRadius: theme.borderRadius['300'],
    blockSize: theme.size['icon-100'],
    inlineSize: theme.size['icon-100'],
    textIndent: '-10000px'
  };
});
export const Badge = _ref => {
  let {
      'data-test-id': dataTestId,
      use = 'free',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isBadge = !(use === 'none' || use === 'count' || use === 'dot');
  const Rendered = use !== 'dot' ? View : Dot;
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(Rendered, Object.assign({}, use !== 'dot' && (isBadge ? getBadgeStyles(use) : CountStyles), rest, {
      children: /*#__PURE__*/_jsx(Text, Object.assign({
        typography: "heading-25",
        textAlign: "center",
        color: use === 'koala' ? 'text-primary-default' : 'text-primary-on-fill-default'
      }, isBadge && {
        textTransform: 'uppercase'
      }, {
        children: children
      }))
    }))
  });
};